export default "__VITE_ASSET__CcZKVB87__ 1920w";